import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {isCatalogBetaWorkType} from "../../constants/catalog-beta-work-types.constants";

@Component({
  selector: "app-catalog-beta-hint",
  templateUrl: "./catalog-beta-hint.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class CatalogBetaHintComponent {
  @Input({required: true}) type = "";
  @Input() compact = false;

  isVisible(): boolean {
    return isCatalogBetaWorkType(this.type);
  }
}
